import { useMemo } from "react";
import { useSelector } from "react-redux";
const useFiltersData = () => {
  const { orders } = useSelector((state) => state.yodaOrders);
  let listFilters = useMemo(() => {
    const filters = {
      // states: [],
      types: [],
      seasons: [],
      lines: [],
    };

    orders?.map((order) => {
      let typeExist = false;

      filters?.types?.filter((type) => {
        if (type.id === order.typeId) typeExist = true;
      });

      if (!typeExist)
        filters?.types.push({
          id: order.typeId,
          labels: order.type,
        });

      let seasonExist = false;

      filters?.seasons?.filter((season) => {
        if (season.id === order.seasonId) seasonExist = true;
      });

      if (!seasonExist)
        filters?.seasons.push({
          id: order.seasonId,
          labels: order.season,
        });

      const lineExist = filters?.lines?.some(
        (line) => line.id === order.lineId || line.id === order.line,
      );

      if (!lineExist)
        filters?.lines.push({
          id: order.lineId || order.line,
          labels: order.lineDescription,
        });
    });

    return filters;
  }, [orders]);

  return { listFilters };
};

export default useFiltersData;
